<template>
  <div class="col-xxl-12 px-0">
    <div
      class="card card-custom card-stretch gutter-b"
      :class="projectTemplateErrors != null ? 'bordered-card-danger' : 'bordered-card-primary'"
    >
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">
            {{ $t('NAVIGATION.ROOT_MENU.TEMPLATES') }}
          </h3>
        </div>
      </div>
      <div class="card-body">
        <ProjectTemplatesTable
          :templateList="projectTemplateList"
          :loadingComplete="loadingComplete"
          :error="projectTemplateErrors"
          type="system"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations
} from "vuex";

import { SET_BREADCRUMB } from "@/core/services/store/system/breadcrumbs.module";

import PageLoader from "@/core/classes/PageLoader.js";
import ProjectTemplatesTable from "@/view/components/tables/ProjectTemplatesTable";

export default {
  name: "ViewSystemTemplates",

  data() {
    return {
      pageLoader: new PageLoader(1),
      refreshTimer: null
    }
  },

  components: {
    ProjectTemplatesTable
  },

  mounted() {
    this.cleanup();
    this.$store.dispatch(SET_BREADCRUMB, [{ title: `${this.$t("NAVIGATION.ROOT_MENU.TEMPLATES")}` }]);
    this.fetchSystemTemplates();
    this.refreshTimer = setInterval(() => {
      this.fetchSystemTemplates();
    }, 10000)
  },

  unmounted() {
    this.cleanup();
  },

  methods: {
    fetchSystemTemplates: function() {
      let payload = {
        route: "api/v1/system_templates",
        params: {
          paginate: false
        },
        relations: {
          language: 'with'
        }
      };
      this.$store.dispatch(GENERIC_RESOURCE, payload)
        .then((res) => {
          this.pageLoader.setCompleteComponent(1);
          this.setProjectTemplateList(res._embedded.project_templates);
        })
        .catch((error) => {
          this.setProjectTemplateErrors(error);
        })
    },
    cleanup: function() {
      this.setProjectTemplateList([]);
      this.setProjectTemplateErrors();
    },
    ...mapMutations({
      setProjectTemplateList: "setProjectTemplateList",
      setProjectTemplateErrors: "setProjectTemplateErrors"
    })
  },

  computed: {
    ...mapGetters([
      "projectTemplateList",
      "projectTemplateErrors"
    ]),
    loadingComplete() {
      return this.pageLoader.getStatus();
    },
  }
}
</script>